import { useEffect, useState, useRef } from "react";
import "./scss/App.scss";
import CanvasGallery from "./components/CanvasGalley";
import MomentsContextProvider from "./context/MomentsContextProvider";
import Navbar from "./components/Navbar";
import { Cache } from "./components/Cache";
import { allMoments, allMembers, thumbUrl, memberPhotoUrl } from "./api";
import Filter from "./components/Filter/Filter";
import LogoAnimation from "./components/LogoAnimation/LogoAnimation";
import { gsap, Power2 } from "gsap";

let updateTimer;

function App() {
    const [isCompareView, setIsCompareView] = useState(false);
    const [isMonthView, setIsMonthView] = useState(true);
    const [willUpdate, setWillUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const navRef = useRef(null);

    const setIsCompareViewTransition = (compare) => {
        setWillUpdate(true);
        clearInterval(updateTimer);
        updateTimer = setTimeout(() => {
            setWillUpdate(false);
            setIsCompareView(compare);
        }, 500);
        return updateTimer;
    };

    const selectYearTransition = () => {
        setWillUpdate(true);
        clearInterval(updateTimer);
        updateTimer = setTimeout(() => {
            setWillUpdate(false);
            setIsMonthView(true);
        }, 500);
        return updateTimer;
    };

    // PRELOAD MOMENT AND MEMBER IMAGES
    useEffect(() => {
        const _moments = [...allMoments.slice(allMoments.length - 5, allMoments.length)];
        _moments.map((moment) => {
            Cache.add(thumbUrl(moment.media.thumb));
            moment.members.map((_id) => {
                const _member = allMembers.find((member) => member.id === _id);
                return Cache.add(memberPhotoUrl(_member.photo));
            });
            return moment;
        });
    }, []);

    useEffect(() => {
        let tl = new gsap.timeline({ delay: 1.2 });
        if (!isLoading && navRef.current) {
            console.log("yes");
            tl.from(navRef.current, { duration: 0.5, y: -100, ease: Power2.easeOut });
            tl.from(".moments-filter", { display: "none", duration: 0.5, y: 30, opacity: 0, ease: Power2.easeOut, delay: 0.2 });
        }
        console.log("current: ", navRef.current);
        return () => {
            tl.kill();
        };
    }, [isLoading, navRef]);

    return (
        <MomentsContextProvider>
            <div className="App">
                <LogoAnimation setIsLoading={setIsLoading} />
                {!isLoading ? (
                    <>
                        {/* COMPARE */}
                        <div className={`gallery-wrapper left ${isCompareView ? "isActive" : ""}`}>
                            <CanvasGallery isActive={isCompareView} willUpdate={willUpdate} isVertical={true} isLeft={true} />
                            <Filter isLeft={true} isVertical={true} />
                        </div>
                        <div className={`gallery-wrapper right ${isCompareView ? "isActive" : ""}`}>
                            <CanvasGallery isActive={isCompareView} willUpdate={willUpdate} isVertical={true} isLeft={false} />
                            <Filter isLeft={false} isVertical={true} />
                        </div>
                        {/* DEFAULT VIEW */}
                        <div className={`gallery-wrapper ${isCompareView ? "" : "isActive"}`}>
                            <CanvasGallery isMaster={true} isActive={!isCompareView} isMonthView={isMonthView} willUpdate={willUpdate} isVertical={false} isLeft={false} selectYearTransition={selectYearTransition} />
                            <Filter isLeft={false} isVertical={false} />
                        </div>
                        <div className="nav-container" ref={navRef}>
                            <Navbar setIsCompareView={setIsCompareViewTransition} isMonthView={isMonthView} setIsMonthView={setIsMonthView} />
                        </div>
                    </>
                ) : (
                    ""
                )}
            </div>
        </MomentsContextProvider>
    );
}

export default App;
